import React from "react";

function AddNoteCard({ onClick }) {
  return (
    <button type="button" className="my-notes-add-card" onClick={onClick}>
      <span className="my-notes-add-icon" aria-hidden="true">
        +
      </span>
      <span>Add a Note</span>
    </button>
  );
}

export default AddNoteCard;
